import React, { FC } from 'react';

import { useTranslations } from '@lang';
import styled from 'styled-components';

import { Button } from '@common/components';
import { ListProps } from './list.types';
import { ListItem } from './ListItem';

import { media } from 'styled-bootstrap-grid';

import { ShowMoreButtonWrapper } from './ListPage.styles';

const ListContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  margin: 30px -9px;

  ${media.md`
    grid-template-columns: repeat(2, 1fr);
  `}

  ${media.lg`
    grid-template-columns: repeat(3, 1fr);
  `}

  > [class] {
    margin-bottom: 40px;
  }
`;

export const List: FC<ListProps> = ({
  hasMoreItems,
  onShowMoreItems,
  renderMetadataRow,
  items = [],
  displayWithBriefDescription,
}) => {
  const { t } = useTranslations();

  return (
    <>
      <ListContainer>
        {(items || []).map((i) => (
          <ListItem
            key={i.id}
            item={i}
            renderMetadataRow={renderMetadataRow}
            displayWithBriefDescription={displayWithBriefDescription}
          />
        ))}
      </ListContainer>

      {hasMoreItems && onShowMoreItems && (
        <ShowMoreButtonWrapper data-cy="show-more-button-wrapper">
          <Button data-cy="show-more-button" onClick={onShowMoreItems}>
            {t('itemsListing.showMoreResults')}
          </Button>
        </ShowMoreButtonWrapper>
      )}
    </>
  );
};
